// Admin → Users — layout route.
//
// `_authed.users.$id` nests under this file, so it MUST render an <Outlet/>
// or the child never mounts. Before 2026-08-15 this file was both the layout
// AND the list with no Outlet, so /users/$id rendered the list instead of the
// detail view. The list now lives in `_authed.users.index.tsx`.
//
// Same bug and same fix as `_authed.pages.tsx` (M4).

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/users')({
  component: () => <Outlet />,
});
